/* eslint-disable react/no-string-refs */
/* eslint-disable react/no-find-dom-node */
import React from 'react'
import ReactDOM from 'react-dom'
import styles from './Email.scss'
import DOMPurify from 'dompurify'
import {
  Typography,
  TextInput,
  Button,
  Dropdown,
  DropdownOption,
  ModalDialog,
  ModalDialogBody,
  ModalDialogContent,
  ModalDialogCloseButton,
  StandardForm,
  FormError,
  FormField,
  FormInputGroup,
  Link,
  TextArea,
  AlertBoxDismissButton,
  GridContainer,
  Row,
  Column,
  Spinner,
  FormLabel,
  FormLabelOptional,
  AlertBox,
  FlexBox,
  ModalDialogButtons,
  Icon,
  FormHelper,
  Box,
  Divider,
} from '@vp/swan'
import Functions from '../../helpers/functions'
import WebToCaseService from '../../services/case/webToCaseService'
import classNames from 'classnames'
import Parser from 'html-react-parser'
import { withTranslation } from 'react-i18next'
import AnalyticsTracking from '../analytics/analytics'
import FormInput from '../formInput/formInput'
import validationHelper from '../../helpers/validationHelper'
import customerProfileHelper from '../../helpers/customerProfileHelper'
import { ReCaptcha } from '../../modules/recaptcha/recaptcha'
import { AssetStoreContext } from '../../contexts/AssetStoreProvider'

class EmailModal extends React.Component {
  static contextType = AssetStoreContext

  constructor(props) {
    super(props)

    const { t } = this.props
    const lng = this.props.locale.toLowerCase().replace('-', '_')
    this.state = {
      shouldShowSelfService: false,
      lastIssue: '',
      reconsiderUrl: '',
      reconsiderLink: false,
      showOrderNumber: false,
      files: [],
      uploadedFiles: [],
      email: new FormInput(),
      firstName: new FormInput(),
      lastName: new FormInput(),
      subject: new FormInput(),
      valueIssue: new FormInput(),
      comment: new FormInput(),
      orderNumber: new FormInput(),
      phoneNumber: new FormInput(),
      company: new FormInput(),
      tenant: props.tenant,
      locale: props.locale,
      slaMessage: this.props.contactChannels.email.slaMsg,
      formMessage: this.props.contactChannels.email.formMsg,
      value: null,
      shown: true,
      alert: null,
      load: null,
      inputError: null,
      fileListUI: null,
      fileTypeAccepted: true,
      fileSizeAccepted: true,
      subjects: t(`${props.tenant}:subjects`, { lng, returnObjects: true }),
      commonTrackingData: {
        pageSection: 'Help Center',
        pageStage: 'Customer Care',
        pageName: 'Help Center:Email Form',
      },
      issueMapping: {
        'Delivery damage': {
          reconsiderSubmit: 'Delivery Damage',
          submitDetail: 'Delivery Damage',
          eventDetail: 'Form Redirect - Email - Delivery Damage',
          emailSubmit: ' ',
          labels: {
            email: 'Replacement - Email Continue',
            deflection: 'Replacement - Deflection',
            reconsider: 'Replacement - Deflection Reconsidered',
          },
          category: {
            deflection: 'Help Center - Self Service',
            email: 'Global Email',
          },
          action: {
            deflection: 'Button Clicked',
            email: 'CARE Case Submitted',
          },
        },
        'Printing quality': {
          reconsiderSubmit: 'Printing Quality',
          submitDetail: 'Printing Quality',
          eventDetail: 'Form Redirect - Email - Printing Quality',
          emailSubmit: ' ',
          labels: {
            email: 'Replacement - Email Continue',
            deflection: 'Replacement - Deflection',
            reconsider: 'Replacement - Deflection Reconsidered',
          },
          category: {
            deflection: 'Help Center - Self Service',
            email: 'Global Email',
          },
          action: {
            deflection: 'Button Clicked',
            email: 'CARE Case Submitted',
          },
        },
        missing_order: {
          reconsiderSubmit: 'Track Order',
          submitDetail: ' ',
          eventDetail: ' ',
          emailSubmit: ' ',
          labels: {
            email: 'Track Order - Email Continue',
            deflection: 'Track Order - Deflection',
            reconsider: 'Track Order - Deflection Reconsidered',
          },
          category: {
            deflection: 'Global Email',
            email: 'Global Email',
          },
          action: {
            deflection: 'Button Clicked',
            email: 'CARE Case Submitted',
          },
        },
      },
      issues_1: [
        { id: 'missing_order', value: t(`${props.tenant}:email.fields.issue.options.option_order_not_arrived`, '', { lng }) },
        { id: 'VAT invoice', value: t(`${props.tenant}:email.fields.issue.options.option_vat_invoice`, '', { lng }) },
        { id: 'Document error', value: t(`${props.tenant}:email.fields.issue.options.option_document_error`, '', { lng }) },
        { id: 'Printing quality', value: t(`${props.tenant}:email.fields.issue.options.option_printing_quality`, '', { lng }) },
        { id: 'Delivery damage', value: t(`${props.tenant}:email.fields.issue.options.option_delivery_damage`, '', { lng }) },
        { id: 'Cancel order', value: t(`${props.tenant}:email.fields.issue.options.option_cancel_order`, '', { lng }) },
        { id: 'Change order', value: t(`${props.tenant}:email.fields.issue.options.option_change_order`, '', { lng }) },
        { id: 'Other', value: t(`${props.tenant}:email.fields.issue.options.option_other`, '', { lng }) },
      ],
      issues_2: [
        { id: 'Document assistance', value: t(`${props.tenant}:email.fields.issue.options.option_document_assitance`, '', { lng }) },
        { id: 'Order assistance', value: t(`${props.tenant}:email.fields.issue.options.option_order_assitance`, '', { lng }) },
        {
          id: 'Product, pricing, service question',
          value: t(`${props.tenant}:email.fields.issue.options.option_product_pricing_service_question`, '', { lng }),
        },
        { id: 'Other', value: t(`${props.tenant}:email.fields.issue.options.option_other`, '', { lng }) },
      ],
      issues_3: [
        { id: 'Reset password', value: t(`${props.tenant}:email.fields.issue.options.option_reset_password`, '', { lng }) },
        { id: 'Unsubscribe from emails', value: t(`${props.tenant}:email.fields.issue.options.option_unsubscribe_from_emails`, '', { lng }) },
        { id: 'Other', value: t(`${props.tenant}:email.fields.issue.options.option_my_account_other`, '', { lng }) },
      ],
      issues_4: [
        { id: 'Creating a website', value: t(`${props.tenant}:email.fields.issue.options.option_creating_website`, '', { lng }) },
        { id: 'Existing website', value: t(`${props.tenant}:email.fields.issue.options.option_existing_website`, '', { lng }) },
        { id: 'Cancel website', value: t(`${props.tenant}:email.fields.issue.options.option_cancel_website`, '', { lng }) },
        { id: 'Other', value: t(`${props.tenant}:email.fields.issue.options.option_other`, '', { lng }) },
      ],
      issues_5: [
        { id: 'Creating an email subscription', value: t(`${props.tenant}:email.fields.issue.options.option_creating_email_subscription`, '', { lng }) },
        { id: 'Existing email subscription', value: t(`${props.tenant}:email.fields.issue.options.option_existing_email_subscription`, '', { lng }) },
        { id: 'Cancel email subscription', value: t(`${props.tenant}:email.fields.issue.options.option_cancel_email_subscription`, '', { lng }) },
        { id: 'Other', value: t(`${props.tenant}:email.fields.issue.options.option_other`, '', { lng }) },
      ],
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleChangeIssue = this.handleChangeIssue.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleOnRedirectSubmit = this.handleOnRedirectSubmit.bind(this)
    this.handleOnReconsiderSubmit = this.handleOnReconsiderSubmit.bind(this)
  }

  ListIssue(state) {
    switch (state) {
      case 'Existing Order':
        return this.state.issues_1.map((v) =>
          v.value ? (
            <DropdownOption id={v.id} key={v.id} value={v.id}>
              {v.value}
            </DropdownOption>
          ) : null,
        )
      case 'New Order':
        return this.state.issues_2.map((v) =>
          v.value ? (
            <DropdownOption id={v.id} key={v.id} value={v.id}>
              {v.value}
            </DropdownOption>
          ) : null,
        )
      case 'My Account':
        return this.state.issues_3.map((v) =>
          v.value ? (
            <DropdownOption id={v.id} key={v.id} value={v.id}>
              {v.value}
            </DropdownOption>
          ) : null,
        )
      case 'Website Subscription':
        return this.state.issues_4.map((v) =>
          v.value ? (
            <DropdownOption id={v.id} key={v.id} value={v.id}>
              {v.value}
            </DropdownOption>
          ) : null,
        )
      default:
    }
  }

  async componentDidMount() {
    // eslint-disable-next-line no-unused-vars
    const recaptcha = new ReCaptcha(this.props.dataConfig.recaptchaSiteKey)
    await customerProfileHelper.getCustomerProfile(this, this.props.auth)
  }

  async componentDidUpdate(prevProps) {
    // Check if `identity` has changed
    if (prevProps.auth?.identity?.isSignedIn !== this.props.auth?.identity?.isSignedIn) {
      await customerProfileHelper.getCustomerProfile(this, this.props.auth)
    }
  }

  handleChange(e) {
    this.setState({ value: e.target.value })
  }

  handleChangeIssue(e) {
    const showOrderNumber =
      this.state.subject.value === 'Existing Order' &&
      this.state.issues_1.filter((obj) => {
        return obj.value === e.target.value && !['VAT invoice', 'Change order'].includes(obj.id)
      }).length > 0

    const shouldShowSelfService = this.state.subject.value === 'Existing Order' && ['missing_order'].includes(e.target.value)

    this.setState({ showOrderNumber })
    this.setState({ shouldShowSelfService })
    this.setState({ lastIssue: e.target.value })
    if (!showOrderNumber) {
      this.setState({ orderNumber: new FormInput() })
    }
    this.setState({ reconsiderLink: false })
    this.setState({
      valueIssue: {
        value: e.target.value,
        error: false,
        errorMessage: undefined,
      },
    })
  }

  ConcatSubjectIssue() {
    return this.state.subject.value + ' - ' + this.state.valueIssue.value
  }

  validateFile(filename, fileSize) {
    const dot = filename.lastIndexOf('.') + 1
    const extFile = filename.substr(dot, filename.length).toLowerCase()
    const acceptedFileType = [
      'pdf',
      'ai',
      'psd',
      'bmp',
      'gif',
      'jpg',
      'jpeg',
      'ppt',
      'pptx',
      'doc',
      'docx',
      'xls',
      'xlsx',
      'pcx',
      'pic',
      'pict',
      'pct',
      'png',
      'ps',
      'tif',
      'tiff',
    ]

    if (!acceptedFileType.includes(extFile)) {
      this.getErrorAlert(1)
      return false
    }

    const fileSizeMax = 6 * 1024 * 1024 // 6M
    if (fileSize > fileSizeMax) {
      this.getErrorAlert(2)
      return false
    }

    return true
  }

  validateFields() {
    const { t } = this.props
    const lng = this.props.locale.toLowerCase().replace('-', '_')
    const context = this.state

    if (!validationHelper.validateSubject(context.subject.value)) {
      this.setState({
        subject: {
          value: context.subject.value,
          error: true,
          errorMessage: t(`${this.props.tenant}:email.fields.subject.errors.empty`, { lng }),
        },
      })
      ReactDOM.findDOMNode(this.refs.subject).focus()
      return false
    }
    if (!validationHelper.validateIssue(context.valueIssue.value)) {
      this.setState({
        valueIssue: {
          value: context.valueIssue.value,
          error: true,
          errorMessage: t(`${this.props.tenant}:email.fields.issue.errors.empty`, { lng }),
        },
      })
      ReactDOM.findDOMNode(this.refs.valueIssue).focus()
      return false
    }
    if (!validationHelper.validateOrderNumber(context.orderNumber.value)) {
      this.setState({
        orderNumber: {
          value: context.orderNumber.value,
          error: true,
          errorMessage: t(`${this.props.tenant}:email.fields.order_number.errors.invalid_format`, { lng }),
        },
      })
      ReactDOM.findDOMNode(this.refs.orderNumber).focus()
      return false
    }
    if (!validationHelper.validatePhoneNumber(context.phoneNumber.value)) {
      this.setState({
        phoneNumber: {
          value: context.phoneNumber.value,
          error: true,
          errorMessage: t(`${this.props.tenant}:email.fields.phone_number.errors.invalid_format`, { lng }),
        },
      })
      ReactDOM.findDOMNode(this.refs.phoneNumber).focus()
      return false
    }
    if (!validationHelper.validateNameEmpty(context.firstName.value)) {
      this.setState({
        firstName: {
          value: context.firstName.value,
          error: true,
          errorMessage: t(`${this.props.tenant}:email.fields.first_name.errors.empty`, { lng }),
        },
      })
      ReactDOM.findDOMNode(this.refs.firstName).focus()
      return false
    }
    if (!validationHelper.validateNameFormat(context.firstName.value)) {
      this.setState({
        firstName: {
          value: context.firstName.value,
          error: true,
          errorMessage: t(`${this.props.tenant}:email.fields.first_name.errors.invalid_format`, { lng }),
        },
      })
      ReactDOM.findDOMNode(this.refs.firstName).focus()
      return false
    }
    if (!validationHelper.validateNameEmpty(context.lastName.value)) {
      this.setState({
        lastName: {
          value: context.lastName.value,
          error: true,
          errorMessage: t(`${this.props.tenant}:email.fields.last_name.errors.empty`, { lng }),
        },
      })
      ReactDOM.findDOMNode(this.refs.lastName).focus()
      return false
    }
    if (!validationHelper.validateNameFormat(context.lastName.value)) {
      this.setState({
        lastName: {
          value: context.lastName.value,
          error: true,
          errorMessage: t(`${this.props.tenant}:email.fields.last_name.errors.invalid_format`, { lng }),
        },
      })
      ReactDOM.findDOMNode(this.refs.lastName).focus()
      return false
    }
    if (!validationHelper.validateEmailAddressEmpty(context.email.value)) {
      this.setState({
        email: {
          value: context.email.value,
          error: true,
          errorMessage: t(`${this.props.tenant}:email.fields.email.errors.empty`, { lng }),
        },
      })
      ReactDOM.findDOMNode(this.refs.email).focus()
      return false
    }
    if (!validationHelper.validateEmailExistingAt(context.email.value)) {
      this.setState({
        email: {
          value: context.email.value,
          error: true,
          errorMessage: t(`${this.props.tenant}:email.fields.email.errors.missing_at`, { lng }),
        },
      })
      ReactDOM.findDOMNode(this.refs.email).focus()
      return false
    }
    if (!validationHelper.validateEmailAddress(context.email.value)) {
      this.setState({
        email: {
          value: context.email.value,
          error: true,
          errorMessage: t(`${this.props.tenant}:email.fields.email.errors.invalid_format`, { lng }),
        },
      })
      ReactDOM.findDOMNode(this.refs.email).focus()
      return false
    }
    if (!validationHelper.validateCompany(context.company.value)) {
      this.setState({
        company: {
          value: context.company.value,
          error: true,
          errorMessage: t(`${this.props.tenant}:email.fields.company_name.errors.invalid_format`, { lng }),
        },
      })
      ReactDOM.findDOMNode(this.refs.company).focus()
      return false
    }
    if (!validationHelper.validateCommentEmpty(context.comment.value)) {
      this.setState({
        comment: {
          value: context.comment.value,
          error: true,
          errorMessage: t(`${this.props.tenant}:email.fields.comments.errors.empty`, { lng }),
        },
      })
      ReactDOM.findDOMNode(this.refs.comment).focus()
      return false
    }
    if (!validationHelper.validateCommentFormat(context.comment.value)) {
      this.setState({
        comment: {
          value: context.comment.value,
          error: true,
          errorMessage: t(`${this.props.tenant}:email.fields.comments.errors.invalid_format`, { lng }),
        },
      })
      ReactDOM.findDOMNode(this.refs.comment).focus()
      return false
    }

    ReactDOM.findDOMNode(this.refs.emailContainer).focus()
    return true
  }

  handleOnSubjectChange = (e) => {
    this.setState({ shouldShowSelfService: false })
    this.setState({ reconsiderLink: false })
    this.setState({ lastIssue: '' })
    this.handleOnChange(e)
  }

  handleOnChange = async (e) => {
    switch (e.target.name) {
      case 'file': {
        const file = e.target.files[0]
        e.target.value = null
        const index = this.state.files.findIndex((item) => item.name === file.name)
        if (index === -1 && this.state.files.length < 3 && this.validateFile(file.name, file.size)) {
          this.setState({
            inputError: null,
          })
          this.getInputFileList(true)
          const uploadedFile = await this.context.uploadAsset(file)

          this.setState((state) => {
            state.files.push(file)
            state.uploadedFiles.push(uploadedFile)
            this.getInputFileList(false)
            return state
          })
        }
        break
      }
      default:
        this.setState({
          [e.target.name]: {
            value: e.target.value,
            error: false,
            errorMessage: undefined,
          },
        })
    }
  }

  handleClick() {
    this.setState({
      shown: !this.state.shown,
    })
    this.setState({
      load: this.getLoader(),
    })
    this.setState({
      alert: null,
    })
  }

  trackEvent = (action, category, label, eventDetail = ' ') => {
    AnalyticsTracking.trackEventWithDetails(action, {
      action,
      category,
      label,
      eventDetail: this.props.callMeService ? `BH;${eventDetail}` : eventDetail,
      ...this.state.commonTrackingData,
    })
  }

  handleOnSubmit = async (e) => {
    e.preventDefault()
    e.stopPropagation()
    const recaptcha = new ReCaptcha(this.props.dataConfig.recaptchaSiteKey)
    this.setState({ shouldShowSelfService: false })
    const { lastIssue, shouldShowSelfService, reconsiderLink, issueMapping } = this.state
    const issue = issueMapping[lastIssue]
    issue && this.setState({ reconsiderLink: true })
    if (shouldShowSelfService) {
      this.trackEvent(issue.action.deflection, issue.category.email, issue.labels.email, issue.submitDetail)
    }

    if (shouldShowSelfService) return
    const valid = this.validateFields()
    if (valid === false) {
      return
    }

    const context = this
    const recaptchaResponse = await recaptcha.generateRecaptchaToken('HelpCenterEmailSubmit')

    if (!recaptchaResponse) {
      context.getErrorAlert(4)
      return
    }

    const webToCaseService = new WebToCaseService()
    if (reconsiderLink) {
      this.trackEvent(issue.action.email, issue.category.email, issue.emailSubmit, issue.reconsiderSubmit)
    }

    if (!reconsiderLink) {
      AnalyticsTracking.trackEventWithDetails('CARE Case Submitted', {
        category: 'Global Email',
        label: ' ',
        pageSection: 'Help Center',
        pageStage: 'Customer Care',
        pageName: 'Help Center:Email Form',
        eventDetail: this.props.callMeService ? 'BH;' : ' ',
      })
    }
    this.handleClick()
    const authorizationHeader = this.props.auth?.identity?.authorizationHeader
    const res = await webToCaseService.submit({ ...context.state, recaptchaResponse }, this.props.dataConfig, authorizationHeader)
    if (!res) {
      context.getErrorAlert(3)
      context.toggle()
    } else {
      context.getSuccessAlert(res)
    }
    context.setState({ load: null })

    return false
  }

  handleOnRedirectSubmit() {
    const { lastIssue, shouldShowSelfService, issueMapping } = this.state
    const issue = issueMapping[lastIssue]
    if (shouldShowSelfService) {
      this.trackEvent(issue.action.deflection, issue.category.deflection, issue.labels.deflection, issue.eventDetail)
    } else {
      return
    }
    const url = `${Functions.getWebsiteUrl()}od`
    this.setState({ reconsiderUrl: url })
    window.location.href = url
  }

  handleOnReconsiderSubmit() {
    const { lastIssue, shouldShowSelfService, issueMapping } = this.state
    if (!shouldShowSelfService) {
      const issue = issueMapping[lastIssue]
      this.trackEvent(issue.action.deflection, issue.category.deflection, issue.labels.reconsider, issue.eventDetail)
    }
  }

  toggle() {
    this.setState({
      shown: !this.state.shown,
    })
  }

  handleRemoveFile = async (e) => {
    const index = this.state.files.findIndex((item) => item.name === e.target.id)
    let deletePromise
    this.setState(async (state) => {
      if (index !== -1) {
        state.files.splice(index, 1)
        const toDelete = state.uploadedFiles.splice(index, 1)
        deletePromise = this.context.deleteAssetByName(toDelete[0]?.name)
      }
      this.getInputFileList(false)
      return state
    })
    if (deletePromise) {
      await deletePromise
    }
  }

  getInputFileList(uploading) {
    const { t } = this.props
    const lng = this.props.locale.toLowerCase().replace('-', '_')
    const getFileList = () => (
      <Row>
        <Column paddingRight="5" span={12} spanXs={10} spanSm={12} spanMd={12} spanLg={12}>
          {this.state.files.map((item, index) => (
            <p key={index}>
              <Button
                className="stylized-button-skin-clear-selection stylized-button-skin-launcher"
                id={item.name}
                skin="secondary"
                size="mini"
                type="button"
                value="delete"
                onClick={this.handleRemoveFile}
              >
                {item.name}
              </Button>
            </p>
          ))}
          {uploading && (
            <Button disabled id="loadingFile" size="mini">
              <Spinner size="tiny" accessibleText={t(`${this.props.tenant}:email.buttons.attach_files.loading`, { lng })} />
            </Button>
          )}
        </Column>
      </Row>
    )

    if (this.state.files.length > 0 || uploading) {
      this.setState({
        fileListUI: getFileList(),
      })
    } else {
      this.setState({
        fileListUI: null,
      })
    }
  }

  getErrorAlert(errorCode) {
    const { t } = this.props
    const lng = this.props.locale.toLowerCase().replace('-', '_')
    let errorMsg = ''
    switch (errorCode) {
      case 1:
        errorMsg = t(`${this.props.tenant}:email.buttons.attach_files.errors.error_file_type`, { lng })
        break
      case 2:
        errorMsg = t(`${this.props.tenant}:email.buttons.attach_files.errors.error_file_size`, { lng })
        break
      case 3:
        errorMsg = t(`${this.props.tenant}:messages.error.description`, { lng })
        break
      case 4:
        errorMsg = t(`${this.props.tenant}:email.buttons.recaptcha_error`, { lng })
        break
      default:
        errorMsg = ''
        break
    }

    const getAlert = () => (
      <AlertBox skin="error" key="error_alert">
        <p className={styles.alertFormSubmit}>{errorMsg}</p>
        <AlertBoxDismissButton accessibleText="X" />
      </AlertBox>
    )

    this.setState({
      inputError: getAlert(),
    })
  }

  getSuccessAlert(res) {
    const { t } = this.props
    const lng = this.props.locale.toLowerCase().replace('-', '_')
    const getAlert = () => (
      <Box p={1}>
        <AlertBox skin="success" key="success_alert">
          <p className={styles.alertFormSubmit}>
            {t(`${this.props.tenant}:messages.success.title`, { lng })}
            <br />
            {Parser(t(`${this.props.tenant}:messages.success.description1`, { lng }))}
            <span className={styles.textBold}>{` ${res.emailAddress} `}</span>
            {Parser(t(`${this.props.tenant}:messages.success.description2`, { lng }))}
          </p>
        </AlertBox>
      </Box>
    )
    this.setState({
      alert: getAlert(),
    })
  }

  handleUpload(event) {
    event.preventDefault()
    const upfile = document.getElementById('file')
    upfile.click()
  }

  getLoader() {
    const { t } = this.props
    const lng = this.props.locale.toLowerCase().replace('-', '_')
    return <Spinner size="super" accessibleText={t(`${this.props.tenant}:search_results.preloader_accessibility_label`, { lng })} />
  }

  openOrderHistory() {
    window.open('/oh', '_blank')
  }

  render() {
    const { t } = this.props
    const lng = this.props.locale.toLowerCase().replace('-', '_')
    const proadvantageType = this.props.proadvantageType
    const isProadvantage = proadvantageType !== ''
    let ohLink = '/oh'
    if (typeof window !== 'undefined') {
      const domPurify = DOMPurify(window)
      if (window.location && window.location.pathname) {
        const localeInPath = window.location.pathname.split('/')[1]
        if (localeInPath.length === 2) {
          ohLink = domPurify.sanitize(`/${localeInPath}/oh`)
        }
      }
    }

    const optionSubject = this.state.subjects.map((v) => (
      <DropdownOption key={v.id} value={v.id}>
        {v.value}
      </DropdownOption>
    ))
    const { shouldShowSelfService, reconsiderLink } = this.state
    const isValidSS = shouldShowSelfService && this.props.locale.toLowerCase() === 'en-us'
    const shown = this.state.shown ? styles.formDisplay : styles.formHide
    return (
      <div className={styles.emailFormContainer}>
        <Column paddingRight="2" span={12} spanXs={12} spanSm={12} spanMd={12} spanLg={12}>
          {!isProadvantage ? (
            <Row>
              <>
                <ModalDialog isOpen={this.props.isModalOpen} onRequestDismiss={() => this.props.closeModal()}>
                  <ModalDialogContent>
                    {/* <ModalDialogNav> */}
                    <ModalDialogCloseButton />
                    {/* </ModalDialogNav> */}
                    <Box pl={6} mt={8}>
                      <Row>
                        <div style={{ display: 'flex' }} ref="emailContainer">
                          <Typography fontSkin="title-section" pb={5}>
                            {t(`${this.props.tenant}:email.title`, { lng })}
                          </Typography>
                        </div>
                      </Row>
                      <ModalDialogBody>
                        <GridContainer>
                          <Row paddingRight="5" pb={6}>
                            <Typography fontSkin="title-item">{this.state.slaMessage}</Typography>
                          </Row>
                          <Row paddingRight="5">
                            <div className={shown}>
                              <Typography fontSkin="body-standard">{this.state.formMessage}</Typography>
                            </div>
                          </Row>
                          <Row paddingRight="5">
                            <Row paddingTop="2" style={{ width: '100%' }}>
                              <Column span={12} spanXs={12} spanSm={12} spanMd={12} spanLg={12}>
                                {this.state.alert}
                                {this.state.load}
                              </Column>
                            </Row>
                            <Row>
                              <StandardForm className={styles.formRow} method="post" onSubmit={this.handleOnSubmit} id="email-widget-form">
                                <div className={shown}>
                                  <Row>
                                    <Column span={12} spanXs={12} spanSm={12} spanMd={12} spanLg={12} marginTop="8">
                                      <Row>
                                        <Column paddingRight="5" span={6} spanXs={12} spanSm={6} spanMd={6} spanLg={6}>
                                          <FormField>
                                            <FormLabel mb={3} className={styles.inputLabel}>
                                              {t(`${this.props.tenant}:email.fields.subject.title`, { lng })}
                                              <span aria-hidden="true">*</span>
                                            </FormLabel>
                                            <FormInputGroup className={styles.inputGroup}>
                                              <Dropdown
                                                id="subject"
                                                name="subject"
                                                aria-required="true"
                                                fullWidth
                                                {...this.state.subject}
                                                onChange={this.handleOnSubjectChange}
                                                ref="subject"
                                              >
                                                {optionSubject}
                                              </Dropdown>
                                              {this.state.subject.error ? <FormError>{this.state.subject.errorMessage}</FormError> : null}
                                            </FormInputGroup>
                                          </FormField>
                                        </Column>
                                        <Column paddingRight="5" span={6} spanXs={12} spanSm={6} spanMd={6} spanLg={6}>
                                          <FormField>
                                            <FormLabel className={styles.inputLabel}>
                                              {t(`${this.props.tenant}:email.fields.issue.title`, { lng })}
                                              <span aria-hidden="true">*</span>
                                            </FormLabel>
                                            <FormInputGroup className={styles.inputGroup}>
                                              <Dropdown
                                                id="issue"
                                                name="issue"
                                                aria-required="true"
                                                fullWidth
                                                {...this.state.valueIssue}
                                                onChange={this.handleChangeIssue}
                                                ref="valueIssue"
                                              >
                                                <DropdownOption value="">
                                                  {t(`${this.props.tenant}:email.fields.issue.options.option_please_select`, { lng })}
                                                </DropdownOption>
                                                {this.ListIssue(this.state.subject.value)}
                                              </Dropdown>
                                              {this.state.valueIssue.error ? <FormError>{this.state.valueIssue.errorMessage}</FormError> : null}
                                            </FormInputGroup>
                                          </FormField>
                                        </Column>
                                      </Row>
                                      {reconsiderLink && this.props.locale.toLowerCase() === 'en-us' && (
                                        <Link pb={4} onClick={this.handleOnReconsiderSubmit} href={'https://www.vistaprint.com/od'}>
                                          {t(`${this.props.tenant}:email.buttons.send_email.order_reconsider_title`, { lng })}
                                        </Link>
                                      )}
                                      {isValidSS ? (
                                        <>
                                          <FlexBox justifyContent="center" alignItems="center" flexDirection="column" pb="2" pt="3">
                                            <Typography fontSize="small" fontWeight="bold" textAlign="center">
                                              {t(`${this.props.tenant}:email.buttons.send_email.order_tracking_description`, { lng })}
                                            </Typography>
                                          </FlexBox>
                                          <GridContainer>
                                            <Row>
                                              <Column span={12}>
                                                <ModalDialogButtons>
                                                  <Button
                                                    skin="primary"
                                                    id="submitbtn"
                                                    aria-label={t(`${this.props.tenant}:email.buttons.send_email.order_tracking_title`, { lng })}
                                                    width="full-width"
                                                    type="button"
                                                    value="Send"
                                                    onClick={this.handleOnRedirectSubmit}
                                                  >
                                                    <span>{t(`${this.props.tenant}:email.buttons.send_email.order_tracking_title`, { lng })}</span>
                                                    <Icon iconType="arrowRight" size="20p" />
                                                  </Button>
                                                </ModalDialogButtons>
                                              </Column>
                                            </Row>
                                          </GridContainer>
                                        </>
                                      ) : (
                                        <>
                                          {this.state.showOrderNumber ? (
                                            <Row>
                                              <Column paddingRight="5" span={6} spanXs={12} spanSm={6} spanMd={6} spanLg={6}>
                                                <FormField>
                                                  <FormLabel className={styles.inputLabel}>
                                                    {t(`${this.props.tenant}:email.fields.order_number.title`, { lng })}{' '}
                                                    <FormLabelOptional>{t(`${this.props.tenant}:email.optional`, { lng })}</FormLabelOptional>
                                                  </FormLabel>
                                                  <FormInputGroup className={styles.inputGroup}>
                                                    <TextInput
                                                      id="orderNumber"
                                                      name="orderNumber"
                                                      {...this.state.orderNumber}
                                                      onChange={this.handleOnChange}
                                                      ref="orderNumber"
                                                    />
                                                    <p className={styles.formDescription}>
                                                      {t(`${this.props.tenant}:email.fields.order_number.description1`, { lng })}
                                                      <br className={styles.rwdbreak} />
                                                      {t(`${this.props.tenant}:email.fields.order_number.description2`, { lng })}
                                                      <Link href={ohLink} target="_blank" rel="noreferrer">
                                                        {t(`${this.props.tenant}:email.fields.order_number.link-text`, { lng })}
                                                      </Link>
                                                      {t(`${this.props.tenant}:email.fields.order_number.description3`, { lng })}
                                                    </p>
                                                    {this.state.orderNumber.error ? <FormError>{this.state.orderNumber.errorMessage}</FormError> : null}
                                                  </FormInputGroup>
                                                </FormField>
                                              </Column>
                                            </Row>
                                          ) : null}
                                          <Row>
                                            <Column paddingRight="5" span={6} spanXs={12} spanSm={6} spanMd={6} spanLg={6}>
                                              <FormField>
                                                <FormLabel className={styles.inputLabel}>
                                                  {t(`${this.props.tenant}:email.fields.first_name.title`, { lng })}
                                                  <span aria-hidden="true">*</span>
                                                </FormLabel>
                                                <FormInputGroup className={styles.inputGroup}>
                                                  <TextInput
                                                    id="firstName"
                                                    name="firstName"
                                                    onChange={this.handleOnChange}
                                                    {...this.state.firstName}
                                                    aria-required="true"
                                                    ref="firstName"
                                                  />
                                                  {this.state.firstName.error ? <FormError>{this.state.firstName.errorMessage}</FormError> : null}
                                                </FormInputGroup>
                                              </FormField>
                                            </Column>
                                            <Column paddingRight="5" span={6} spanXs={12} spanSm={6} spanMd={6} spanLg={6}>
                                              <FormField>
                                                <FormLabel className={styles.inputLabel}>
                                                  {t(`${this.props.tenant}:email.fields.last_name.title`, { lng })} <span aria-hidden="true">*</span>{' '}
                                                </FormLabel>
                                                <FormInputGroup className={styles.inputGroup}>
                                                  <TextInput
                                                    id="lastName"
                                                    name="lastName"
                                                    {...this.state.lastName}
                                                    onChange={this.handleOnChange}
                                                    aria-required="true"
                                                    ref="lastName"
                                                  />
                                                  {this.state.lastName.error ? <FormError>{this.state.lastName.errorMessage}</FormError> : null}
                                                </FormInputGroup>
                                              </FormField>
                                            </Column>
                                          </Row>
                                          <Row>
                                            <Column paddingRight="5" span={12} spanXs={12} spanSm={12} spanMd={12} spanLg={12}>
                                              <FormField>
                                                <FormLabel className={styles.inputLabel}>
                                                  {t(`${this.props.tenant}:email.fields.email.title`, { lng })}
                                                  <span aria-hidden="true">*</span>
                                                </FormLabel>
                                                <FormInputGroup className={styles.inputGroup}>
                                                  <TextInput
                                                    id="email"
                                                    name="email"
                                                    {...this.state.email}
                                                    onChange={this.handleOnChange}
                                                    aria-required="true"
                                                    ref="email"
                                                  />
                                                  {this.state.email.error ? <FormError>{this.state.email.errorMessage}</FormError> : null}
                                                </FormInputGroup>
                                              </FormField>
                                            </Column>
                                          </Row>
                                          <Row>
                                            <Column paddingRight="5" span={12} spanXs={12} spanSm={12} spanMd={12} spanLg={12}>
                                              <FormField>
                                                <FormLabel className={styles.inputLabel}>
                                                  {t(`${this.props.tenant}:email.fields.phone_number.title`, { lng })}
                                                </FormLabel>
                                                <FormInputGroup className={styles.inputGroup}>
                                                  <TextInput
                                                    id="phoneNumber"
                                                    name="phoneNumber"
                                                    {...this.state.phoneNumber}
                                                    onChange={this.handleOnChange}
                                                    ref="phoneNumber"
                                                  />
                                                  {this.state.phoneNumber.error ? <FormError>{this.state.phoneNumber.errorMessage}</FormError> : null}
                                                </FormInputGroup>
                                              </FormField>
                                            </Column>
                                          </Row>
                                          <Row>
                                            <Column paddingRight="5" span={12} spanXs={12} spanSm={12} spanMd={12} spanLg={12}>
                                              <FormField>
                                                <FormLabel className={styles.inputLabel}>
                                                  {t(`${this.props.tenant}:email.fields.company_name.title`, { lng })}
                                                </FormLabel>
                                                <FormInputGroup className={styles.inputGroup}>
                                                  <TextInput id="company" name="company" {...this.state.company} onChange={this.handleOnChange} ref="company" />
                                                  {this.state.company.error ? <FormError>{this.state.company.errorMessage}</FormError> : null}
                                                </FormInputGroup>
                                              </FormField>
                                            </Column>
                                          </Row>
                                          <Row>
                                            <Column paddingRight="5" span={12} spanXs={12} spanSm={12} spanMd={12} spanLg={12}>
                                              <FormField>
                                                <FormLabel className={styles.inputLabel}>
                                                  {t(`${this.props.tenant}:email.fields.comments.title`, { lng })}
                                                  <span aria-hidden="true">*</span>
                                                </FormLabel>
                                                <FormInputGroup className={styles.inputGroup}>
                                                  <TextArea
                                                    id="comment"
                                                    name="comment"
                                                    {...this.state.comment}
                                                    rows="5"
                                                    maxLength="1000"
                                                    onChange={this.handleOnChange}
                                                    fullWidth
                                                    aria-required="true"
                                                    resize="vertical"
                                                    ref="comment"
                                                  />
                                                  {this.state.comment.error ? <FormError>{this.state.comment.errorMessage}</FormError> : null}
                                                  <FormHelper>{this.state.comment.value.length}/1000</FormHelper>
                                                </FormInputGroup>
                                              </FormField>
                                            </Column>
                                          </Row>
                                          {this.state.fileListUI}
                                          <Row>
                                            <Column paddingRight="5" span={12} spanXs={12} spanSm={12} spanMd={12} spanLg={12}>
                                              <GridContainer>
                                                <Row>
                                                  <FlexBox alignItems="center" justifyContent="center">
                                                    <Column span={3}>
                                                      <Button
                                                        type="file"
                                                        className="attach-files-button"
                                                        width="standard"
                                                        aria-label={t(`${this.props.tenant}:email.buttons.attach_files.title`, { lng })}
                                                        onClick={this.handleUpload}
                                                      >
                                                        {t(`${this.props.tenant}:email.buttons.attach_files.title`, { lng })}
                                                      </Button>
                                                      <input
                                                        id="file"
                                                        aria-label={t(`${this.props.tenant}:email.buttons.attach_files.title`, { lng })}
                                                        className={classNames({
                                                          [`${styles.inputUploadFile}`]: true,
                                                          textbutton: true,
                                                          'textbutton-skin-secondary': true,
                                                        })}
                                                        name="file"
                                                        size="20"
                                                        type="file"
                                                        onChange={this.handleOnChange}
                                                      />
                                                    </Column>
                                                    <Column span={9}>
                                                      <p className={styles.attachFilesText}>
                                                        {t(`${this.props.tenant}:email.buttons.attach_files.comment`, { lng })}
                                                      </p>
                                                    </Column>
                                                  </FlexBox>
                                                </Row>
                                              </GridContainer>
                                              {this.state.inputError}
                                            </Column>
                                          </Row>
                                        </>
                                      )}
                                      <Divider mt={6} mb={6} />
                                      <Row>
                                        <Column paddingRight="5" span={12} spanXs={12} spanSm={12} spanMd={12} spanLg={12}>
                                          <Button
                                            skin={isValidSS ? 'secondary' : 'primary'}
                                            id="submitbtn"
                                            aria-label={
                                              isValidSS
                                                ? t(`${this.props.tenant}:email.buttons.send_email.alternate_title`, { lng })
                                                : t(`${this.props.tenant}:email.buttons.send_email.title`, { lng })
                                            }
                                            width="standard"
                                            type="button"
                                            value="Send"
                                            onClick={this.handleOnSubmit}
                                          >
                                            {isValidSS
                                              ? t(`${this.props.tenant}:email.buttons.send_email.alternate_title`, { lng })
                                              : t(`${this.props.tenant}:email.buttons.send_email.title`, { lng })}
                                          </Button>
                                          <p className={styles.attachFilesText}>{t(`${this.props.tenant}:email.fields.comments.security`, { lng })}</p>
                                        </Column>
                                      </Row>
                                    </Column>
                                  </Row>
                                </div>
                              </StandardForm>
                            </Row>
                          </Row>
                        </GridContainer>
                      </ModalDialogBody>
                    </Box>
                  </ModalDialogContent>
                </ModalDialog>
              </>
            </Row>
          ) : null}
        </Column>
      </div>
    )
  }
}

EmailModal.contextType = AssetStoreContext

export default withTranslation()(EmailModal)
